// 系统管理相关页面组件
import EmptyRouterView from '../components/EmptyRouterView/index.vue'
import UserManagement from '../views/system/UserManagement.vue'
import RoleManagement from '../views/system/RoleManagement.vue'
import PermissionManagement from '../views/system/PermissionManagement.vue'
import DepartmentManagement from '../views/system/DepartmentManagement.vue'
import LogManagement from '../views/system/LogManagement.vue'
import DictManagement from '../views/system/DictManagement.vue'

// 系统管理路由配置
export const systemRoutes = {
  path: 'system',
  name: 'System',
  component: EmptyRouterView,
  meta: {
    title: '系统管理',
    icon: 'el-icon-setting',
    hidden: false
  },
  children: [
    {
      path: 'user',
      name: 'UserManagement',
      component: UserManagement,
      meta: {
        title: '用户管理',
        icon: 'el-icon-user',
        hidden: false
      }
    },
    {
      path: 'role',
      name: 'RoleManagement',
      component: RoleManagement,
      meta: {
        title: '角色管理',
        icon: 'el-icon-s-custom',
        hidden: false
      }
    },
    {
      path: 'permission',
      name: 'PermissionManagement',
      component: PermissionManagement,
      meta: {
        title: '权限管理',
        icon: 'el-icon-key',
        hidden: false
      }
    },
    {
      path: 'department',
      name: 'DepartmentManagement',
      component: DepartmentManagement,
      meta: {
        title: '部门管理',
        icon: 'el-icon-office-building',
        hidden: false
      }
    },
    {
      path: 'dict',
      name: 'DictManagement',
      component: DictManagement,
      meta: {
        title: '字典管理',
        icon: 'el-icon-document',
        hidden: false
      }
    },
    {
      path: 'log',
      name: 'LogManagement',
      component: LogManagement,
      meta: {
        title: '日志管理',
        icon: 'el-icon-document-copy',
        hidden: false
      }
    }
  ]
}